<template lang="pug">
div
  h2(v-html="field.values[0]")
  p(v-if="field.values[1]", v-html="field.values[1]")
</template>

<script>
export default {
  name: "Sub Header",
  props: {
    field: Object,
  },
};
</script>

<style lang="scss" scoped>
h2 {
  display: flex;
  flex-direction: column;
  font-weight: 300;
  padding: 0;
  margin: 0 0 1rem;
  line-height: 1;
  &:only-child {
    margin: 0 0 2.75rem;
  }
}
p {
  margin: 0 0 1.75rem;
}
</style>
